export { default as SearchTray } from './SearchTray';